module.exports = __webpack_public_path__ + "static/media/errordeletedsurvey.b541044d.svg";